import type { NewThreadDraft } from '@components/ArtBoard/Threads/types'
import { artBoardActions } from '@store/reducers/artboard'
import { ThreadsActions } from '@store/reducers/threads'
import { useDispatch } from 'react-redux'

export const useNewThread = () => {
  const dispatch = useDispatch()

  // `author` is what the form committed: a guest's own name, or '' for a member
  // and for a guest who gave none. The backend overrides it from the profile
  // for a signed-in author anyway, so an empty one is simply left out.
  return (content: string, draft: NewThreadDraft, author: string) => {
    dispatch(artBoardActions.changeMode('edit'))
    dispatch(
      ThreadsActions.create({
        content,
        ...draft,
        ...(author ? { author } : {}),
      })
    )
  }
}
